import { render, staticRenderFns } from "./add-edit-memo.vue?vue&type=template&id=6ab80fe0&scoped=true&"
import script from "./add-edit-memo.vue?vue&type=script&lang=js&"
export * from "./add-edit-memo.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-memo.vue?vue&type=style&index=0&id=6ab80fe0&scoped=true&lang=css&"
import style1 from "./add-edit-memo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab80fe0",
  null
  
)

export default component.exports